import React from 'react';
import './Backpacksprayer.css';

const Backpacksprayer = () => {
    return (
        <div className="Backpacksp-container">
            <h2>Comparison of the cost of extrusion and injection molding systems:</h2>
            <div className="Backpackspr-text">
                <p>Injection Molding Machine For Backpack Sprayer Model K500V6 Cost About:<strong className="Backpack"> $7****</strong></p>
            </div>

            <div className="Backpackspr-text">           
                <p>Extrusion Blow Molding System For Backpack Sprayer (15L~30L) Model EB250P85PS1 Cost About:<strong className="Backpack"> $5****</strong> </p>
            </div>
        </div>
    );
};

export default Backpacksprayer;
